import { render } from "./JobsHeader.vue?vue&type=template&id=90e31bfa"
import script from "./JobsHeader.vue?vue&type=script&lang=js"
export * from "./JobsHeader.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__